






























































































































































































































import Vue from "vue";
import _ from "lodash";
import { Form } from "element-ui";
import config from "../config/index";
import { exportFiles } from "../common/util";
import { mapState, mapActions } from "vuex";
import store from "../store/store";
import { TaskData } from "../types/common";
import { ContrastCheckData, OptData, CheckFileDto } from "../types/contrastCheck";
import { uploadFileStatus } from "../common/filters";

declare var _hmt: any;
declare var captcha: any;

export default Vue.extend({
	name: "contrastCheck",
	data(): ContrastCheckData {
		return {
			// paperType: 'newPaper',
			hintText: "该文件已上传成功!",
			isTraditionalLocal: false,
			markLocal: false,
			isShowRecallSucess: false,
			isShowRecallOneSucess: false,
			markOneLocal: false,
			checkTypeLocal: "upload",
			checkTypeLocalOne: "uploadOne",
			isTraditional: false,
			isFolder: false,
			isDb: false,
			isShowDbName: false,
			isShowFolderName: false,
			isChangeDb: false,
			isShowChangeDb: false,
			isOpenTips: true,
			isShowAddFolder: false,
			isAddFolder: false,
			oldFolderId: "",
			listLoading: false,
			isCheckResultTip: false,
			checkTime: 0,
			fileNum: 0,
			isCanCheck: false,
			checkIds: [],
			selectFileList: [],
			uploadFileList: [],
			copyUploadFileList: [],
			cacheUploadFileList: [],
			taskList: [],
			dbsList: [],
			checkdbidList: [],
			isInitRule: false, // 是否需要初始化验证规则
			$refs: {
				ruleForm: Form,
				ruleOneForm: Form,
				folderForm: Form,
				ruleFormOne: Form,
				localUploadForm: Form,
				localOneUploadForm: Form,
			},
			folderForm: {
				newTask: "",
				taskId: "",
				taskName: "",
			},
			folderRules: {
				newTask: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请输入文件夹名称"));
							} else if (value.length > 50) {
								callback(new Error("文件夹名称不能大于50位"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				taskId: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请选择文件夹"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			showSucces: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请选择文件夹"));
							} else {
								callback();
							}
						},
					},
				],
			},
			ruleForm: {
				title: "",
				author: "",
				studentId: "",
				tutor: "",
				content: "",
				publishTime: "",
			},
			ruleFormOne: {
				title: "",
				author: "",
				content: "",
			},
			localUploadForm: {
				title: "",
				author: "",
				checkId: "",
				publishTime: "",
			},
			localOneUploadForm: {
				title: "",
				author: "",
				checkId: "",
				publishTime: "",
			},
			ruleLocalUploadForm: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写题名"));
							} else if (value.length > 200) {
								callback(new Error("题名长度不超过200字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				author: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 150) {
								callback(new Error("作者名称长度不超过150字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				content: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请粘贴文本"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			rules: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写题名"));
							} else if (value.length > 200) {
								callback(new Error("题名长度不能大于200个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				author: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 150) {
								callback(new Error("作者名称长度不能大于150个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				studentId: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 30) {
								callback(new Error("学号名称长度不能大于30个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				tutor: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 30) {
								callback(new Error("导师名称长度不能大于30个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				content: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请粘贴文本"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
		};
	},
	mounted() {
		this.changePaperType("publish");
	},
	computed: mapState({
		userInfo: (state: any) => store.getters.getUserInfo,
		// permission: (state: any) => store.getters.getPermission,
		paperType: (state: any) => store.getters.getPaperType,
		checkType: (state: any) => store.getters.getCheckType,
		uploader: (state: any) => store.getters.getUploader,
	}),
	watch: {
		checkType(newVal) {
			this.checkTypeLocal = newVal;
		},
	},
	methods: {
		// 将字符数转换为word统计模式
		fnGetCpmisWords(str: string) {
			let sLen = 0;
			//先将回车换行符做特殊处理
			str = str.replace(/(\r\n+|\s+|　+)/g, "龘");
			//处理英文字符数字，连续字母、数字、英文符号视为一个单词
			str = str.replace(/[\x00-\xff]/g, "m");
			//合并字符m，连续字母、数字、英文符号视为一个单词
			str = str.replace(/m+/g, "*");
			//去掉回车换行符
			str = str.replace(/龘+/g, "");
			//返回字数
			sLen = str.length;
			return sLen;
		},
		// 重置文件夹状态
		resetFolder() {
			this.isFolder = false;
			this.isShowFolderName = false;
			this.folderForm = {
				newTask: "",
				taskId: "",
				taskName: "",
			};
			this.resetForm("folderForm");
		},
		// 重置所有表单
		resetAllForm() {
			this.resetForm("ruleFormOne");
			this.resetForm("ruleForm");
			this.resetForm("localOneUploadForm");
			this.resetForm("localUploadForm");
			this.checkTypeLocal = "upload";
			this.checkTypeLocalOne = "uploadOne";
			this.isShowRecallSucess = false;
			this.isShowRecallOneSucess = false;
			this.resetFolder();
		},
		// 修改检测类型触发方法
		changeCheckType() {
			this.$store.dispatch("setCheckType", this.checkTypeLocal);
			// this.resetFolder();
			// this.resetForm('ruleForm');
		},
		// 修改文献类型触发方法
		changePaperType(type: string) {
			// end
			this.$store.dispatch("setPaperType", type);
			this.$store.dispatch("setCheckType", "upload");
			this.$nextTick(() => {
				this.resetFolder();
			});
		},
		// 修改温馨提示状态
		changeTipsStatus() {
			this.isOpenTips = !this.isOpenTips;
			// 记录用户操作
			localStorage.setItem("isOpenTips", this.isOpenTips.toString());
		},
		// 获取文件夹列表
		getTaskList() {
			this.$http.get("/api/TaskManage/GetTaskDropdownList").then((data: any) => {
				this.taskList = data.data;
			});
		},
		// 是否添加至文件夹
		changeFolderStatus(val: boolean) {
			if (!this.isFolder) {
				this.isShowFolderName = this.isFolder;
			}
			this.isShowAddFolder = val && !this.isShowFolderName;
		},
		// 关闭文件夹弹窗
		closeFolderDialog() {
			if (!this.isShowFolderName) {
				this.isFolder = false;
			}
		},
		// 改变文件夹类型事件
		changeFolderType() {
			this.$refs.folderForm.resetFields();
		},
		// 已有文件夹change事件
		changeTask(id: string) {
			let obj: TaskData | any = {};
			obj = this.taskList.find((item: TaskData) => {
				return item.taskId === id;
			});
			this.folderForm.taskName = (obj && obj.taskName) || "";
		},
		// 创建文件夹
		createFolder() {
			this.$http
				.post(`/api/TaskManage/CreateTask`, {
					taskName: this.folderForm.newTask,
				})
				.then((data: any) => {
					const result = data.data;
					Object.assign(this.folderForm, {
						taskId: result.taskId,
						taskName: result.taskName,
					});
					this.isAddFolder = true;
					this.getTaskList();
					this.$message({
						message: `创建成功`,
						type: "success",
					});
					this.isShowFolderName = true;
					this.changeFolderStatus(false);
				});
		},
		// 添加至文件夹
		intoFolder() {
			this.$refs.folderForm.validate((valid: any) => {
				if (valid) {
					if (!this.isAddFolder) {
						this.createFolder();
					} else {
						this.isShowFolderName = true;
						this.changeFolderStatus(false);
					}
				}
			});
		},
		// 新文献检测开始检测
		startCheck(type: string, formName?: string) {
			const param = {
				TaskId: this.folderForm.taskId,
				SendCheckId: "",
				SendTitle: "",
				SendAuthor: "",
				SendStudentNo: "",
				SendTutor: "",
				SendContent: "",
				ThanTitle: "",
				ThanAuthor: "",
				ThanContent: "",
				ThanCheckId: "",
			};
			// end
			// 无痕验证
			(param as any).nvc = captcha.getNVCVal();
			// end
			let SendTitle = this.ruleForm.title || this.localOneUploadForm.title;
			let SendCheckId = this.ruleForm.checkId || this.localOneUploadForm.checkId;
			let ThanTitle = this.ruleFormOne.title || this.localUploadForm.title;
			let ThanCheckId = this.localUploadForm.checkId;
			let SendAuthor = this.ruleForm.author;
			let SendStudentNo = this.ruleForm.studentId;
			let SendTutor = this.ruleForm.tutor;
			let SendContent = this.ruleForm.content;
			let ThanContent = this.ruleFormOne.content;
			let ThanAuthor = this.ruleFormOne.author;
			if (type === "one2one") {
				Object.assign(param, {
					SendTitle,
					SendCheckId,
					ThanTitle,
					ThanCheckId,
				});
				if (!this.localOneUploadForm.title || !this.localUploadForm.title) {
					this.$alert(" 请先上传文献！", "提示");
					return false;
				}
				if (!this.markOneLocal && !this.markLocal) {
					this.$alert("文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。", "提示");
					return false;
				}
				this.isCanCheck = true;
				this.$http
					.post("/api/HDCheck/OneByOneCheck", param)
					.then((data: any) => {
						// 无痕验证未通过
						this.isCanCheck = false;
						if (!captcha.callback(data.data)) {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
							return;
						} else if (data.data.success) {
							this.$message({
								message: `送检成功`,
								type: "success",
							});
							// 重新更新全局状态
							this.$store.dispatch("setUserInfo");
							this.checkTime = data.data.checkTime;
							this.isCheckResultTip = true;
							this.resetForm("ruleFormOne");
							this.resetForm("ruleForm");
						} else {
							if (data.data.message === "余额不足") {
								this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
							} else if (data.data.message === "交易错误") {
								this.$alert("交易错误，请稍后重试!", "提示");
							} else {
								this.$message({
									message: data.data.message,
									type: "error",
								});
							}
							this.$store.dispatch("setUserInfo");
						}
					})
					.catch(() => {
						this.$store.dispatch("setLoading", {
							isShow: false,
						});
					});
			} else if (type === "one2two") {
				Object.assign(param, {
					SendTitle,
					SendCheckId,
					ThanTitle,
					SendAuthor,
					SendStudentNo,
					SendTutor,
					SendContent,
					ThanContent,
					ThanAuthor,
				});
				this.resetForm("localUploadForm");
				this.$refs["ruleFormOne"].validate((valid: any) => {
					if (valid) {
						this.$store.dispatch("setLoading", {
							isShow: true,
						});
						this.isCanCheck = true;
						this.$http
							.post("/api/HDCheck/OneByOneCheck", param)
							.then((data: any) => {
								this.isCanCheck = false;
								// 无痕验证未通过
								if (!captcha.callback(data.data)) {
									this.$store.dispatch("setLoading", {
										isShow: false,
									});
									return;
								} else if (data.data.success) {
									this.$message({
										message: `送检成功`,
										type: "success",
									});
									// 重新更新全局状态
									this.$store.dispatch("setUserInfo");
									// this.getNotCheckList();
									this.checkTime = data.data.checkTime;
									this.isCheckResultTip = true;
									this.resetForm("ruleFormOne");
								} else {
									if (data.data.message === "余额不足") {
										this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
									} else if (data.data.message === "交易错误") {
										this.$alert("交易错误，请稍后重试!", "提示");
									} else {
										if (data.data.message === "提交比对文献字数不能超过100万字符") {
											this.editRuleAndTriggerValid(data.data.message, 0);
											this.isInitRule = true;
										}
										this.$message({
											message: data.data.message,
											type: "error",
										});
									}
									this.$store.dispatch("setUserInfo");
								}
							})
							.catch(() => {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
							});
					}
				});
			} else if (type === "two2one") {
				Object.assign(param, {
					SendTitle,
					ThanTitle,
					ThanCheckId,
					SendAuthor,
					SendStudentNo,
					SendTutor,
					SendContent,
					ThanContent,
					ThanAuthor,
				});
				this.$refs["ruleForm"].validate((valid: any) => {
					if (valid) {
						this.$store.dispatch("setLoading", {
							isShow: true,
						});
						this.isCanCheck = true;
						this.$http
							.post("/api/HDCheck/OneByOneCheck", param)
							.then((data: any) => {
								this.isCanCheck = false;
								// 无痕验证未通过
								if (!captcha.callback(data.data)) {
									this.$store.dispatch("setLoading", {
										isShow: false,
									});
									return;
								} else if (data.data.success) {
									this.$message({
										message: `送检成功`,
										type: "success",
									});
									// 重新更新全局状态
									this.$store.dispatch("setUserInfo");
									// this.getNotCheckList();
									this.checkTime = data.data.checkTime;
									this.isCheckResultTip = true;
									this.resetForm("ruleForm");
									this.resetForm("localOneUploadForm");
								} else {
									if (data.data.message === "余额不足") {
										this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
									} else if (data.data.message === "交易错误") {
										this.$alert("交易错误，请稍后重试!", "提示");
									} else {
										if (data.data.message === "提交送检文献字数不能超过100万字符") {
											this.editRuleAndTriggerValid(data.data.message, 1);
											this.isInitRule = true;
										}
										this.$message({
											message: data.data.message,
											type: "error",
										});
									}
									this.$store.dispatch("setUserInfo");
								}
							})
							.catch(() => {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
							});
					}
				});
			} else if (type === "two2two") {
				Object.assign(param, {
					SendTitle,
					ThanTitle,
					SendAuthor,
					SendStudentNo,
					SendTutor,
					SendContent,
					ThanContent,
					ThanAuthor,
				});
				this.$refs["ruleForm"].validate((valid: any) => {
					if (valid) {
						this.$refs["ruleFormOne"].validate((valid: any) => {
							if (valid) {
								this.$store.dispatch("setLoading", {
									isShow: true,
								});
								this.isCanCheck = true;
								this.$http
									.post("/api/HDCheck/OneByOneCheck", param)
									.then((data: any) => {
										this.isCanCheck = false;
										// 无痕验证未通过
										if (!captcha.callback(data.data)) {
											this.$store.dispatch("setLoading", {
												isShow: false,
											});
											return;
										} else if (data.data.success) {
											this.$message({
												message: `送检成功`,
												type: "success",
											});
											// 重新更新全局状态
											this.$store.dispatch("setUserInfo");
											// this.getNotCheckList();
											this.checkTime = data.data.checkTime;
											this.isCheckResultTip = true;
											this.resetForm("ruleFormOne");
											this.resetForm("ruleForm");
											this.resetForm("localOneUploadForm");
											this.resetForm("localUploadForm");
										} else {
											if (data.data.message === "余额不足") {
												this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
											} else if (data.data.message === "交易错误") {
												this.$alert("交易错误，请稍后重试!", "提示");
											} else if (data.data.message === "提交送检文献字数不能超过100万字符") {
												this.editRuleAndTriggerValid(data.data.message, 1);
												this.isInitRule = true;
											} else if (data.data.message === "提交比对文献字数不能超过100万字符") {
												this.editRuleAndTriggerValid(data.data.message, 0);
												this.isInitRule = true;
											} else {
												this.$message({
													message: data.data.message,
													type: "error",
												});
											}
											this.$store.dispatch("setUserInfo");
										}
									})
									.catch(() => {
										this.$store.dispatch("setLoading", {
											isShow: false,
										});
									});
							}
						});
					}
				});
			}
			//this.resetAllForm();
		},

		initRule() {
			if (this.isInitRule) {
				this.rules = {
					title: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请填写题名"));
								} else if (value.length > 50) {
									callback(new Error("题名长度不能大于50个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					author: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("作者名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					studentId: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("学号名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					tutor: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("导师名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					content: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请粘贴文本"));
								} else {
									callback();
								}
							},
							trigger: "change",
						},
					],
				};
				this.ruleLocalUploadForm = {
					title: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请填写题名"));
								} else if (value.length > 50) {
									callback(new Error("题名长度不超过50字符"));
								} else {
									callback();
								}
							},
							trigger: "change",
						},
					],
					author: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("作者名称长度不超过30字符"));
								} else {
									callback();
								}
							},
							trigger: "change",
						},
					],
					content: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请粘贴文本"));
								} else {
									callback();
								}
							},
							trigger: "change",
						},
					],
				};
			}
			this.isInitRule = false;
		},
		// 修改验证规则并立即触发(实现非预定义规则的错误提示)
		editRuleAndTriggerValid(msgList: any, formNum: number) {
			let formRule = formNum ? this.rules : this.ruleLocalUploadForm;
			let form = formNum ? "ruleForm" : "ruleFormOne";
			if (msgList) {
				(formRule as any).content = [
					{
						validator: (rule: any, value: any, callback: any) => {
							callback(new Error(msgList));
						},
					},
				];
				this.validFrom(form);
			}
		},

		validFrom(fromType: any) {
			let res = false;
			this.$refs[fromType].validate((valid: any) => {
				if (!valid) {
					res = false;
				} else {
					res = true;
				}
			});
			return res;
		},
		// 清空、重置表单
		resetForm(formName: any) {
			if (this.$refs[formName]) {
				this.$refs[formName].resetFields();
			}
		},
		// 跳转到检测结果
		toCheckResult() {
			let path = "/myCheckInfo";

			this.$router.push({
				path,
			});
		},
		// 判断上传文件状态
		judgeStatus() {
			let mark = true;
			this.uploadFileList.forEach((item: any) => {
				if (item.status !== "Success") {
					mark = false;
				}
			});
			return mark;
		},
		// 上传错误回调
		handleError(error: any, file: any, type: string) {
			console.log(error);
			this.isTraditional = false;
			this.isTraditionalLocal = false;
			if (error === "Q_TYPE_DENIED" && file.size !== 0) {
				this.$message({
					message: "文件格式不正确，仅限doc,docx,pdf",
					type: "error",
				});
			} else if (error === "F_EXCEED_SIZE") {
				// this.$message({
				//   message: `文件大小超过上限50M，请重新上传`,
				//   type: 'error'
				// });
			} else if (error === "Q_EXCEED_NUM_LIMIT") {
				this.$message({
					message: "单次送检不超过1篇",
					type: "error",
				});
			}
		},
		// 上传成功回调
		publishHandleSuccess(file: any, response: any) {
			this.isTraditional = false;
			this.isTraditionalLocal = false;
			if (response.success) {
				((this.localUploadForm.title = response.title),
					(this.localUploadForm.author = response.author),
					(this.localUploadForm.checkId = response.checkId),
					(this.localUploadForm.publishTime = response.uploadTimeStr));
				this.markLocal = true;
				this.isShowRecallSucess = true;
				// this.$message({
				//   message: '上传文件成功',
				//   type: 'success'
				// });
			} else {
				this.$message({
					message: response.message,
					type: "error",
				});
			}
		},
		publishOneHandleSuccess(file: any, response: any) {
			if (response.success) {
				((this.localOneUploadForm.title = response.title),
					(this.localOneUploadForm.author = response.author),
					(this.localOneUploadForm.checkId = response.checkId),
					(this.localOneUploadForm.publishTime = response.uploadTimeStr));
				this.markOneLocal = true;
				this.isShowRecallOneSucess = true;
				// this.$message({
				//   message: '上传文件成功',
				//   type: 'success'
				// });
			} else {
				this.$message({
					message: response.message,
					type: "error",
				});
			}
			this.isTraditional = false;
		},
		// 禁止上传提示
		tips() {
			this.$alert("当前还有未上传完的文档，请在完成后继续选择文档上传", "提示");
			return false;
		},
		// 初始化上传组件
		initUploader(domId: string, opt: OptData) {
			// 初始化前，如果有上传对象，清空上传队列
			if (this.uploader) {
				this.uploader.reset();
				// this.getNotCheckList();
			}
			const webUploaderOpt = {
				auto: true, // 是否自动上传
				fileNumLimit: 1,
				// fileSingleSizeLimit: opt.type === 'newPaper' ? 50 * 1024 * 1024 : undefined,
				threads: 1,
				// swf文件路径
				swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
				// 文件接收服务端。
				server: `${config.api}/api/HDCheck/Upload?isOneByOne=true`,
				// 选择文件的按钮。可选。
				// 内部根据当前运行是创建，可能是input元素，也可能是flash.
				pick: {
					id: domId,
					multiple: false,
				},
				// 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
				resize: false,
				duplicate: true,
				accept: {
					title: "Documents",
					extensions: "doc,docx,pdf",
					mimeTypes: ".docx,.doc,.pdf",
				},
			};
			const WebUploader: any = (window as any).WebUploader;
			const uploader = WebUploader.create(webUploaderOpt);
			this.$store.dispatch("setUploader", uploader);
			uploader.on("uploadBeforeSend", function (obj: any, data: any, headers: any) {
				data.isOneByOne = true;
			});
			// 进入队列前触发
			uploader.on("beforeFileQueued", (file: any) => {
				this.isShowRecallOneSucess = false;
				this.isTraditional = true;
				this.localOneUploadForm.title = file.name;
			});
			// 当有文件被添加进队列的时候
			uploader.on("fileQueued", (file: any) => {
				// 单篇上传加遮罩层
				if (!opt.multiple) {
					this.$store.dispatch("setLoading", {
						isShow: true,
						text: "正在上传，请稍后！",
					});
				}
			});
			uploader.on("startUpload", (file: any, response: any) => {});
			uploader.on("uploadSuccess", (file: any, response: any) => {
				this.isTraditional = false;
				if (!response) {
					this.$message({
						message: response.message,
						type: "error",
					});
					return false;
				}
				if (domId === "#publish") {
					this.publishHandleSuccess(file, response);
				}
				if (domId === "#publish-one") {
					this.publishOneHandleSuccess(file, response);
				}
			});
			uploader.on("error", (error: any, file: any) => {
				this.handleError(error, file, opt.type);
			});
			uploader.on("uploadFinished", () => {
				this.isCanCheck = false;
				this.cacheUploadFileList = [];
				uploader.reset();
				this.$nextTick(() => {
					this.fileNum = this.uploadFileList.length;
					// 单篇上传加遮罩层
					if (!opt.multiple) {
						this.$store.dispatch("setLoading", {
							isShow: false,
							text: "正在加载...",
						});
					}
				});
			});
		},
		// 初始化对比文献上传组件
		initUploaderConstrast(domId: string, opt: OptData) {
			// 初始化前，如果有上传对象，清空上传队列
			if (this.uploader) {
				this.uploader.reset();
				// this.getNotCheckList();
			}

			const webUploaderOptOne = {
				auto: true, // 是否自动上传
				// fileSingleSizeLimit: opt.type === 'newPaper' ? 50 * 1024 * 1024 : undefined,
				// fileSingleSizeLimitStr: opt.type === 'newPaper' ? '50M' : undefined,
				fileNumLimit: 1,
				threads: 1,
				// swf文件路径
				swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
				// 文件接收服务端。
				server: `${config.api}/api/HDCheck/UploadThanPaper`,
				// 选择文件的按钮。可选。
				// 内部根据当前运行是创建，可能是input元素，也可能是flash.
				pick: {
					id: domId,
					multiple: false,
				},
				// 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
				resize: false,
				duplicate: true,
				accept: {
					title: "Documents",
					extensions: "doc,docx,pdf",
					mimeTypes: ".docx,.doc,.pdf",
				},
			};
			const WebUploader: any = (window as any).WebUploader;
			const uploaderOne = WebUploader.create(webUploaderOptOne);
			this.$store.dispatch("setUploader", uploaderOne);

			// 进入队列前触发
			uploaderOne.on("beforeFileQueued", (file: any) => {
				this.isShowRecallSucess = false;
				this.isTraditionalLocal = true;
				this.localUploadForm.title = file.name;
			});
			uploaderOne.on("uploadBeforeSend", function (obj: any, data: any, headers: any) {
				// data.DelFilePath = parentObj.siblings(".upload-path").val();
				//  data.ItemCode = $("#txtItemCode").val();
				data.isOneByOne = true;
			});
			// 当有文件被添加进队列的时候
			uploaderOne.on("fileQueued", (file: any) => {
				// 单篇上传加遮罩层
				if (!opt.multiple) {
					this.$store.dispatch("setLoading", {
						isShow: true,
						text: "正在上传，请稍后！",
					});
				}
			});
			uploaderOne.on("startUpload", (file: any, response: any) => {});
			uploaderOne.on("uploadSuccess", (file: any, response: any) => {
				this.isTraditionalLocal = false;
				if (!response) {
					this.$message({
						message: response.message,
						type: "error",
					});
					return false;
				}
				if (domId === "#publish") {
					this.publishHandleSuccess(file, response);
				}
				if (domId === "#publish-one") {
					this.publishOneHandleSuccess(file, response);
				}
			});
			uploaderOne.on("error", (error: any, file: any) => {
				this.handleError(error, file, opt.type);
			});
			uploaderOne.on("uploadFinished", () => {
				this.isCanCheck = false;
				this.cacheUploadFileList = [];
				uploaderOne.reset();
				this.$nextTick(() => {
					// 单篇上传加遮罩层
					if (!opt.multiple) {
						this.$store.dispatch("setLoading", {
							isShow: false,
							text: "正在加载...",
						});
					}
				});
			});
		},
	},
	created() {
		this.$store.dispatch("setPaperType", "newPaper");
		this.$store.dispatch("setCheckType", "upload");
		this.getTaskList();
		// this.getNotCheckList();
		this.$nextTick(() => {
			this.initUploader("#publish-one", {
				multiple: true,
				fileNumLimit: 1,
				type: "newPaper",
			});
			this.initUploaderConstrast("#publish", {
				multiple: true,
				fileNumLimit: 1,
				type: "newPaper",
			});
		});
		// 获取用户操作
		this.isOpenTips = localStorage.getItem("isOpenTips") !== "false";
	},
});
